﻿import { Component, ChangeDetectionStrategy, ViewChild, EventEmitter, Output, Input, ElementRef, Pipe, LOCALE_ID, Inject  } from "@angular/core";
import { startOfDay, endOfDay, isSameDay, isSameMonth, subDays, addDays } from "date-fns";
import { CalendarEvent, CalendarMonthViewDay, CalendarEventTimesChangedEvent, CalendarEventTitleFormatter } from "angular-calendar";
import { Router } from "@angular/router";
import { DataService } from "../services/dataService";
import { FormatDateTimePipe } from "../pipes/formatDateTime.pipe";
import { Subject } from "rxjs";
import * as _ from "lodash";
import { CalendarGetWeekViewArgs , CalendarUtils  } from "angular-calendar";
import * as moment from 'moment';


export class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
    constructor( @Inject(LOCALE_ID) private locale: string) {
        super();
    }
    public month(event: any): string {
        return `${event.Secondarytitle}`;
    }

    public locales:any= this.locale;
}


const colors: any = {
    blocked: {
        primary: "#EF5350",
        secondary: "#EF5350"
    },
    schedule: {
        primary: "#FFD393",
        secondary: "#FFD393"
    },
    available: {
        primary: "#66BB6A",
        secondary: "#66BB6A"
    }
};

@Component({
    selector: "jax-calendarcomponent",
    templateUrl: "./calendar.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: CalendarEventTitleFormatter,
            useClass: CustomEventTitleFormatter
        }
    ]
})
export class CalendarComponent {
    public view: string = "month";
    public viewDate: Date = new Date();
    public dateGoto: string;
    public events: CalendarEvent[] = [];
    public refresh: Subject<any> = new Subject();
    public activeDayIsOpen: boolean = true;
    public defaultCalendarType: boolean = false;
    public avialableEvents: CalendarEvent[] = [];
    public scheduleEvents: CalendarEvent[] = [];
    // exclude weekends
    public excludeDays: number[] = [0, 6];
    public dayView: any;
    public weekView: any;
    public weekdays: any;
    public hourSegment: any;
    public datetimeFormat : FormatDateTimePipe = new FormatDateTimePipe();
    public JSON:any=JSON;
    

    @ViewChild("toggleSwitch") toggleSwitch: any;
    @Input() calType: boolean;
    @Output() onSelectDate: EventEmitter<any> = new EventEmitter<string>();
    @Output() onToggle: EventEmitter<any> = new EventEmitter<string>();

    constructor(private dataService: DataService, private router: Router, private calendarUtil: CalendarUtils) {
    }

    public ngAfterViewInit() {
    }


    public selectDate(control: any) {
        if (this.dateGoto) {
            this.onSelectDate.emit(this.dateGoto);
            this.viewDate = new Date(this.dateGoto);
        } else {
            // this.onSelectDate.emit(this.viewDate.toString());
            this.viewDate = (new Date(this.viewDate.getTime() - this.viewDate.getTimezoneOffset() * -60000));
            this.onSelectDate.emit(moment(this.viewDate, "MM-DD-YYYY"));
        }
    }

    public dayClicked({ date, events }: { date: Date, events: CalendarEvent[] }): void {
        if (isSameMonth(date, this.viewDate)) {
            if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen) || events.length === 0) {
                this.activeDayIsOpen = false;
            } else {
                this.activeDayIsOpen = true;
                this.viewDate = date;
            }
        }
    }

    public displayCalendar(scheduleCalendardata: any, availablecalendardata: any, displayType: string, date: Date) {
        this.avialableEvents = [];
        this.scheduleEvents = [];

        this.updateSwitchColor(displayType);

        for (let d of availablecalendardata) {
            let event = {
                title: d.CaseDisplayNumber + " " + d.HearingType,
                Secondarytitle: this.datetimeFormat.transform(d.StartDateTime, "hh:mm a") + " - " + this.datetimeFormat.transform(d.EndDateTime,"hh:mm a") + " " + d.CaseDisplayNumber + " " + d.HearingType,
                start: moment(d.StartDateTime, "YYYY-MM-DD HH:mm:ss").toDate(),
                end: moment(d.EndDateTime, "YYYY-MM-DD HH:mm:ss").toDate() ,
                color: colors.available,
                eventType: 2
            };
            this.avialableEvents.push(event);
        }

        for (let d of scheduleCalendardata) {
            let event = {
                title: d.CaseDisplayNumber + " " + d.HearingType,
                Secondarytitle: this.datetimeFormat.transform(d.StartDateTime, "hh:mm a") + " - " + this.datetimeFormat.transform(d.EndDateTime, "hh:mm a") + " " + d.CaseDisplayNumber + " " + d.HearingType,
                start: moment(d.StartDateTime, "YYYY-MM-DD HH:mm:ss").toDate(),
                end: moment(d.EndDateTime, "YYYY-MM-DD HH:mm:ss").toDate(),
                color: (d.CaseDisplayNumber === "Blocked" ? colors.blocked : colors.schedule),
                eventType: (d.CaseDisplayNumber === "Blocked" ? 1 : 0)
            };
            this.scheduleEvents.push(event);
        }

        if (displayType === "Available") {
            this.events = this.avialableEvents; 
            this.toggleSwitch.checked = true;
        } else {
            this.events = this.scheduleEvents;
            this.toggleSwitch.checked = false;
        }

        //this.viewDate = moment(date).toDate();
        let startDate = new Date(date);
        this.viewDate = (new Date(startDate.getTime() + Math.abs(startDate.getTimezoneOffset() * 60000)));
        this.ViewType(this.view, "");
        this.refresh.next();
        this.activeDayIsOpen = false;
    }

    public skipWeekends(direction: "back" | "forward"): void {
        if (this.view === "day") {
            if (direction === "back") {
                while (this.excludeDays.indexOf(this.viewDate.getDay()) > -1) {
                    this.viewDate = subDays(this.viewDate, 1);
                }
            } else if (direction === "forward") {
                while (this.excludeDays.indexOf(this.viewDate.getDay()) > -1) {
                    this.viewDate = addDays(this.viewDate, 1);
                }
            }
        }
    }

    private updateSwitchColor(displayType) {
        if (displayType === "Available") {
            this.toggleSwitch.defaultBgColor = colors.available.primary;
        } else {
            this.toggleSwitch.defaultBgColor = colors.blocked.primary;
        }
    }

    public onChange(event: boolean) {
        event = this.calType.toString() === "0" || this.calType.toString() === "false" ? true : false;
        //event = this.toggleSwitch.checked;
        if (event) {
            this.updateSwitchColor("Available");
            this.onToggle.emit("1");
            this.events = this.avialableEvents;
            this.toggleSwitch.checked = true;
            this.activeDayIsOpen = false;
        } else {
            this.updateSwitchColor("Schedule");
            this.onToggle.emit("0");
            this.events = this.scheduleEvents;
            this.toggleSwitch.checked = false;
            this.activeDayIsOpen = false;
        }

        this.ViewType(this.view, "");
    }


    public ViewType(type: string, obj: any) {
        this.view = type;

        if (type === "day") {
            this.dayView = this.calendarUtil.getDayView({
                events: this.events,
                viewDate: this.viewDate,
                hourSegments: 4,
                dayStart: {
                    hour: 8,
                    minute: 0
                },
                dayEnd: {
                    hour: 17,
                    minute: 0
                },
                eventWidth: 150,
                segmentHeight: 30
            });

            this.hourSegment = this.calendarUtil.getDayViewHourGrid({
                viewDate: this.viewDate,
                hourSegments: 4,
                dayStart: {
                    hour: 8,
                    minute: 0
                },
                dayEnd: {
                    hour: 17,
                    minute: 0
                }
            });

        } else if (type === "week") {
            this.events.forEach(e=>e.allDay=true);
            let weekArgs : CalendarGetWeekViewArgs ={
            events : this.events,
            viewDate: this.viewDate,
            excluded: this.excludeDays,
            absolutePositionedEvents: true,
            weekStartsOn: 0,
            hourSegments : 4,
            dayEnd:17,
            dayStart:8,
            segmentHeight:1
            };

            this.weekView = this.calendarUtil.getWeekView(weekArgs);

            this.weekdays = this.calendarUtil.getWeekViewHeader({
                viewDate: this.viewDate,
                weekStartsOn: 0,
                excluded: this.excludeDays,
                weekendDays: this.excludeDays
            });
        }
    }

    public renderTitle(eventRow: any, day: number): string {
        let event = eventRow;
        if (event != null) {
            if (event.eventType === 0) {
                return "<div class='cal-event cal-schedule'><div class='cal-event-title'>" +
                    event.Secondarytitle +
                    "</div></div>";
            } else if (event.eventType === 1) {
                return "<div class='cal-event cal-blocked'><div class='cal-event-title'>" +
                    event.Secondarytitle +
                    "</div></div>";
                //return "<div class='cal-event cal-blocked'><div class='cal-event-title'>" + event.event.title + "</div>";
            } else {
                return "<div class='cal-event cal-available'><div class='cal-event-title'>" +
                    event.Secondarytitle +
                    "</div></div>";
                //return "<div class='cal-event cal-available'><div class='cal-event-title'>" + event.event.title + "</div>";    
            }
        } else {
            return "";
        }
    }

    public renderDayTitle(segment: any): string {
        let event = this.dayView.events.filter(r => moment(r.event.start, "YYYY-MM-DD HH:mm:ss").toDate().getTime() === segment.date.getTime());
        if (event != null) {
            let totalevents = "";
            for (let e of event) {
                if (e.event.eventType === 0) {
                    totalevents = totalevents + " <div class='col-sm-4 left0'> <div class='cal-event cal-starts-within-day cal-ends-within-day cal-schedule'><div class='cal-event-title'>" +
                        e.event.Secondarytitle +
                        "</div></div></div>";
                } else if (e.event.eventType === 1) {
                    totalevents = totalevents +   "<div class='col-sm-4 left0'> <div class='cal-event cal-starts-within-day cal-ends-within-day cal-blocked'><div class='cal-event-title'>" +
                        e.event.Secondarytitle +
                        "</div></div></div>";
                    //return "<div class='cal-event cal-blocked'><div class='cal-event-title'>" + event.event.title + "</div>";
                } else {    
                    totalevents = totalevents +   "<div class='col-sm-4 left0'>  <div class='cal-event cal-starts-within-day cal-ends-within-day cal-available'><div class='cal-event-title'>" +
                        e.event.Secondarytitle +
                        "</div></div></div>";
                    //return "<div class='cal-event cal-available'><div class='cal-event-title'>" + event.event.title + "</div>";    
                }
            }
            return totalevents;
        } else {
            return "";
        }
    }
}



